import React from 'react'

const DocumentIconSvg = ({ fillColor, size, strokeWidth }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30 4H12C10.9391 4 9.92172 4.42143 9.17157 5.17157C8.42143 5.92172 8 6.93913 8 8V40C8 41.0609 8.42143 42.0783 9.17157 42.8284C9.92172 43.5786 10.9391 44 12 44H36C37.0609 44 38.0783 43.5786 38.8284 42.8284C39.5786 42.0783 40 41.0609 40 40V14L30 4Z" stroke={fillColor} stroke-width={strokeWidth ? strokeWidth : "4"} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M28 4V12C28 13.0609 28.4214 14.0783 29.1716 14.8284C29.9217 15.5786 30.9391 16 32 16H40" stroke={fillColor} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20 18H16" stroke={fillColor} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M32 26H16" stroke={fillColor} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M32 34H16" stroke={fillColor} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}

export default DocumentIconSvg